"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tacAuthorizationStatusRequest = exports.tacValidateOTPRequest = exports.softTokenRequest = exports.hardTokenValidate = void 0;
const requestUtil_1 = require("../requestUtil");
const configurations_1 = require("../configurations");
// eslint-disable-next-line import/prefer-default-export
function hardTokenValidate(body, headers, isFinancial) {
    return __awaiter(this, void 0, void 0, function* () {
        return isFinancial
            ? (0, requestUtil_1.fetchRequest)((0, configurations_1.getServer)().MS_UI_TOKEN_MANAGEMENT + configurations_1.PATH.TRANSACTION_SIGN_VERIFY, 'POST', body, headers, true, true)
            : (0, requestUtil_1.fetchRequest)((0, configurations_1.getServer)().MS_UI_TOKEN_MANAGEMENT + configurations_1.PATH.MAINTENANCE_SIGN_VERIFY, 'POST', body, headers, true, true);
    });
}
exports.hardTokenValidate = hardTokenValidate;
function softTokenRequest(body, headers) {
    return __awaiter(this, void 0, void 0, function* () {
        return (0, requestUtil_1.fetchRequest)((0, configurations_1.getServer)().MS_UI_TOKEN_MANAGEMENT + configurations_1.PATH.TRANSACTION_SIGN_REQUEST, 'POST', body, headers, true, true);
    });
}
exports.softTokenRequest = softTokenRequest;
const tacValidateOTPRequest = (data, headers) => {
    const url = (0, configurations_1.getServer)().MS_UI_TOKEN_MANAGEMENT + configurations_1.PATH.TRANSACTION_SIGN_VERIFY_OTP;
    return (0, requestUtil_1.fetchRequest)(url, 'POST', data, headers);
};
exports.tacValidateOTPRequest = tacValidateOTPRequest;
const tacAuthorizationStatusRequest = (data, headers) => {
    const url = (0, configurations_1.getServer)().MS_UI_TOKEN_MANAGEMENT + configurations_1.PATH.TRANSACTION_SIGN_STATUS;
    return (0, requestUtil_1.fetchRequest)(url, 'POST', data, headers, true, true);
};
exports.tacAuthorizationStatusRequest = tacAuthorizationStatusRequest;
